// Mock data for Infinity Solutions Hub Marketing Agency

export const companyInfo = {
  name: "Infinity Solutions Hub",
  tagline: "One-stop Shop For All your Business Needs",
  phone: "702-605-7282",
  email: "Info@infinitysolutionshub.com",
  location: "Las Vegas, NV",
  logoLight: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/qibhv86o_Black%20and%20Green%20Modern%20Business%20Card.svg",
  logoDark: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/qibhv86o_Black%20and%20Green%20Modern%20Business%20Card.svg",
  promotion: "Call us today and get 20% OFF on your first service!",
};

export const services = [
  {
    id: 1,
    slug: "website-development",
    title: "Website Development",
    shortTitle: "Web Dev",
    description: "Custom, responsive websites that convert visitors into customers. From landing pages to full e-commerce solutions.",
    fullDescription: "Transform your online presence with our expert website development services. We create stunning, high-performance websites that not only look amazing but drive real business results.",
    color: "mid-blue",
    icon: "Globe",
    features: ["Custom Design", "Mobile Responsive", "SEO Optimized", "Fast Loading"],
    benefits: [
      "Increase online visibility and credibility",
      "Convert more visitors into paying customers",
      "24/7 availability for your business",
      "Easy content management systems",
      "Secure and reliable hosting solutions"
    ],
    process: [
      { step: 1, title: "Discovery", desc: "We learn about your business, goals, and target audience" },
      { step: 2, title: "Design", desc: "Create wireframes and visual designs for your approval" },
      { step: 3, title: "Development", desc: "Build your website with clean, optimized code" },
      { step: 4, title: "Launch", desc: "Test, optimize, and launch your new website" }
    ]
  },
  {
    id: 2,
    slug: "social-media-marketing",
    title: "Social Media Marketing",
    shortTitle: "Social Media",
    description: "Strategic content creation and community management across all major platforms to grow your brand presence.",
    fullDescription: "Build a powerful social media presence that engages your audience and drives business growth. Our social media experts create compelling content strategies tailored to your brand.",
    color: "mid-purple",
    icon: "Share2",
    features: ["Content Strategy", "Community Management", "Influencer Outreach", "Analytics"],
    benefits: [
      "Build brand awareness and recognition",
      "Engage directly with your target audience",
      "Drive traffic to your website",
      "Generate leads and increase sales",
      "Stay ahead of competitors"
    ],
    process: [
      { step: 1, title: "Audit", desc: "Analyze your current social presence and competitors" },
      { step: 2, title: "Strategy", desc: "Develop a customized content and engagement plan" },
      { step: 3, title: "Creation", desc: "Produce high-quality content that resonates" },
      { step: 4, title: "Growth", desc: "Monitor, optimize, and scale your social success" }
    ]
  },
  {
    id: 3,
    slug: "digital-marketing",
    title: "Digital Marketing",
    shortTitle: "PPC & SEO",
    description: "Data-driven PPC campaigns and SEO strategies that maximize your ROI and drive qualified traffic.",
    fullDescription: "Dominate search results and reach your ideal customers with our comprehensive digital marketing services. From SEO to paid advertising, we deliver measurable results.",
    color: "mid-orange",
    icon: "TrendingUp",
    features: ["Google Ads", "SEO Optimization", "Conversion Tracking", "A/B Testing"],
    benefits: [
      "Appear at the top of search results",
      "Reach customers actively searching for your services",
      "Track and measure every marketing dollar",
      "Outperform competitors in your market",
      "Generate consistent, qualified leads"
    ],
    process: [
      { step: 1, title: "Research", desc: "Deep dive into keywords, competitors, and opportunities" },
      { step: 2, title: "Setup", desc: "Configure campaigns, tracking, and optimization tools" },
      { step: 3, title: "Launch", desc: "Go live with targeted campaigns and SEO improvements" },
      { step: 4, title: "Optimize", desc: "Continuously improve performance and ROI" }
    ]
  },
  {
    id: 4,
    slug: "branding",
    title: "Branding & Creative",
    shortTitle: "Branding",
    description: "Build a memorable brand identity with logo design, brand guidelines, and creative assets.",
    fullDescription: "Create a brand that stands out and connects with your audience. Our branding experts craft unique visual identities that communicate your values and differentiate you from competitors.",
    color: "mid-pink",
    icon: "Palette",
    features: ["Logo Design", "Brand Guidelines", "Visual Identity", "Marketing Collateral"],
    benefits: [
      "Stand out from the competition",
      "Build trust and credibility with customers",
      "Create consistent brand recognition",
      "Attract your ideal target audience",
      "Increase perceived value of your products/services"
    ],
    process: [
      { step: 1, title: "Discovery", desc: "Understand your vision, values, and target market" },
      { step: 2, title: "Concept", desc: "Develop multiple creative directions for your brand" },
      { step: 3, title: "Refinement", desc: "Perfect your chosen direction with your feedback" },
      { step: 4, title: "Delivery", desc: "Provide complete brand assets and guidelines" }
    ]
  },
  {
    id: 5,
    slug: "software-development",
    title: "Software Development",
    shortTitle: "Software Dev",
    description: "End-to-end custom software engineering, from tailored business systems to blockchain-backed platforms that scale with you.",
    fullDescription: "We work closely with businesses to design and develop tailored software systems that simplify workflows and support scalable growth. From initial discovery and UX design to engineering, refinement and delivery, we handle every layer so you can focus on running the business.",
    color: "mid-green",
    icon: "Code",
    features: ["Custom Software", "Blockchain Solutions", "SaaS Platforms", "API & Integrations"],
    benefits: [
      "Simplify complex operational workflows",
      "Unlock scalable growth with systems built for your model",
      "Replace manual work with automated, reliable processes",
      "Ship blockchain-backed products with confidence",
      "Own your code, your data, and your roadmap"
    ],
    process: [
      { step: 1, title: "Discover", desc: "Map your workflows, pain points and business goals" },
      { step: 2, title: "Design", desc: "Architect the system and design intuitive UX flows" },
      { step: 3, title: "Develop", desc: "Engineer the product with clean, production-grade code" },
      { step: 4, title: "Refine & Deliver", desc: "Iterate, QA, launch and support post-delivery" }
    ]
  }
];

export const portfolioWorks = [
  {
    id: 1,
    title: "Summit Healthcare Center",
    description: "Complete healthcare website with patient portal integration",
    url: "https://summithealthcarecenter.com",
    categories: ["Website", "Branding"],
    bgColor: "light-pink",
    logo: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/2nspfxhw_shc-logo-0003.webp"
  },
  {
    id: 2,
    title: "Your Weight Loss Partner",
    description: "Health & wellness platform with booking system",
    url: "https://yourweightlosspartner.com",
    categories: ["Website", "Digital Marketing"],
    bgColor: "light-yellow",
    logo: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/02u7mlxi_YWLP-logo-final-2048x804.webp"
  },
  {
    id: 3,
    title: "U and I Spread the Light",
    description: "Non-profit organization website with donation integration",
    url: "https://uandispreadthelight.com",
    categories: ["Website", "Social Media"],
    bgColor: "grey",
    logo: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/o9lkkugm_U%26I.png"
  },
  {
    id: 4,
    title: "Space Equity Corp",
    description: "Corporate real estate investment platform",
    url: "https://spaceequitycorp.com/",
    categories: ["Website", "Branding"],
    bgColor: "mid-purple",
    logo: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/50sexqga_space-equity-corp-LOGO%20%281%29.webp"
  },
  {
    id: 5,
    title: "SK Stones USA",
    description: "Premium stone supplier e-commerce platform",
    url: "https://skstonesusa.com/",
    categories: ["Website", "Digital Marketing"],
    bgColor: "mid-blue",
    logo: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/kbsz9lrf_sk-stones-logo_white-e1721739403504.webp"
  },
  {
    id: 6,
    title: "Magnolia Countertops",
    description: "Premium countertops and stone surfaces showroom",
    url: "https://magnoliacountertops.info/",
    categories: ["Website", "Branding"],
    bgColor: "mid-orange",
    logo: "https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/fg7id23a_ChatGPT-Image-Jan-25-2026-08_01_04-PM.webp"
  }
];

export const pricingPackages = [
  {
    id: 1,
    name: "Business Presence Starter",
    price: "$850",
    tagline: "Perfect for new businesses that need a strong online presence fast.",
    bgColor: "grey",
    features: [
      "3–4 page website OR one-page landing site",
      "Brand colors + fonts setup",
      "Social media profile setup",
      "5 custom social posts",
      "Basic logo cleanup if needed"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Quick Launch Website",
    price: "$1,200",
    tagline: "For small businesses, nonprofits, and home services.",
    bgColor: "mid-blue",
    features: [
      "5-page WordPress website",
      "Mobile responsive design",
      "Contact form integration",
      "Basic SEO setup",
      "Google Business Profile setup",
      "Delivery in 10–14 days"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Growth Marketing Package",
    price: "$699/mo",
    tagline: "Build Visibility. Attract Customers. Grow Consistently.",
    bgColor: "mid-purple",
    features: [
      "12 branded posts per month",
      "Scheduled on Instagram, Facebook, TikTok or LinkedIn",
      "Monthly website health check",
      "Basic SEO improvements & speed optimization",
      "Google Business Profile management",
      "Monthly strategy call",
      "Simple analytics report"
    ],
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Video Testimonial",
    videoUrl: "https://customer-assets.emergentagent.com/job_9c5eb6ee-d364-498d-aed5-7f3a580d5e0f/artifacts/ln26lzg4_Testimonial.mp4",
    isVideo: true
  }
];

export const stats = [
  { value: "50+", label: "Projects Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "6+", label: "Years Experience" },
  { value: "24/7", label: "Support Available" }
];
